import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"


export default function Profile() {

    const { user } = useSelector((state) => state.auth)

    const navigate = useNavigate()

    useEffect(() => {
        if (!user) {
            navigate('/login')
            return
        }

        // If user has a public profile, navigate to it. Otherwise, navigate to preferences to enable
        if (user.preferences.publicProfile?.enabled === true) {
            navigate(`/profile/${user.preferences.publicProfile.displayName}`)
        } else {
            navigate('/preferences')
        }
    }, [user])

    return null
}